import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-youtube-video-insights-identity',
  templateUrl: './help-youtube-video-insights-identity.component.html'
})
export class HelpYoutubeVideoInsightsIdentityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
